import { extract } from '../extractors/holders';
import { judgeTop1, judgeTop10 } from '../judgments/holderConcentration';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);

export function getHoldersEvidence(project, a, lang = 'zh') {
  const d = extract(project, a);
  if (!d) return [];
  const rows = [];
  if (d.top10Concentration != null) {
    const j = judgeTop10(d.top10Concentration);
    rows.push({
      label: txt(lang, '前10持有占比', 'Top 10 Holders'),
      val: `${j?.emoji || ''} ${d.top10Concentration.toFixed(1)}%`.trim(),
      source: 'Surf', positive: j?.positive ?? null,
    });
  }
  if (d.top1Pct != null) {
    const j = judgeTop1(d.top1Pct);
    rows.push({
      label: txt(lang, '最大持有者占比', 'Top 1 Holder'),
      val: `${j?.emoji || ''} ${d.top1Pct.toFixed(2)}%`.trim(),
      source: 'Surf', positive: j?.positive ?? null,
    });
  }
  return rows;
}

export function HoldersCard({ project, a, lang = 'zh', S, C }) {
  const d = extract(project, a);
  if (!d || d.holders.length === 0) return null;
  return (
    <div style={S?.card || { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12 }}>
      <div style={{ fontSize: 10, fontWeight: 700, color: C?.muted || '#6b7280', marginBottom: 10, textTransform: 'uppercase' }}>
        👥 {txt(lang, '前10持有者浓度', 'Top 10 Holder Concentration')}
        <span style={{ marginLeft: 8, fontWeight: 400, fontSize: 9, color: '#94a3b8' }}>Surf · {d.chain || '—'}</span>
      </div>
      <table style={{ width: '100%', fontSize: 11, borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f9fafb', color: C?.muted || '#6b7280' }}>
          <th style={{ padding: '4px 6px', textAlign: 'left' }}>#</th>
          <th style={{ padding: '4px 6px', textAlign: 'left' }}>{txt(lang, '地址 / 标签', 'Address / Label')}</th>
          <th style={{ padding: '4px 6px', textAlign: 'right' }}>%</th>
        </tr></thead>
        <tbody>
          {d.holders.slice(0, 10).map((h, i) => (
            <tr key={i} style={{ borderBottom: `1px solid ${C?.faint || '#f3f4f6'}` }}>
              <td style={{ padding: '4px 6px' }}>{i + 1}</td>
              <td style={{ padding: '4px 6px', fontFamily: 'monospace', fontSize: 10 }}>
                {h.label || (h.address ? h.address.slice(0, 6) + '…' + h.address.slice(-4) : '—')}
              </td>
              <td style={{ padding: '4px 6px', textAlign: 'right', fontWeight: 600 }}>{h.percent != null ? h.percent.toFixed(2) + '%' : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
